<template>
  <BaseNavDetail
    class="navbar-top navbar-dark"
    id="navbar-main"
    :show-toggle-button="false"
    :backUrl="backUrl"
    expand
  >
    <ul class="navbar-nav align-items-center d-none d-md-flex ml-lg-auto">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center cursor-pointer" slot="title">
            <div class="media-body mr-2 d-none d-lg-block">
              <span class="mb-0 text-sm text-muted">
                <i class="fas fa-bell mr-2"></i> {{ $store.state.user.name }}
              </span>
            </div>
            <span class="avatar avatar-sm">
              <!--<img
                alt="Image placeholder"
                :src="require(`http://localhost:8082/img/logo-app.69681dc7.png`)"
              />-->
            </span>
          </div>

          <template>
            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <!-- <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>Settings</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-calendar-grid-58"></i>
              <span>Activity</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-support-16"></i>
              <span>Support</span>
            </router-link> -->
            <div class="dropdown-divider"></div>
            <a href="#" @click="openModal()" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>Profile</span>
            </a>

            <div class="dropdown-divider"></div>
            <a href="#" @click="doLogout" class="dropdown-item">
              <i class="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
    <modal-profile
      v-if="modalVisible"
      @close="modalVisible = false"
      class="overlay"
    ></modal-profile>
  </BaseNavDetail>
</template>
<script>
import BaseNavDetail from '../../components/BaseNavDetail.vue';
import ModalProfile from '../../components/Goverment/Modal/Profile/ModalProfile.vue';
export default {
  props: ['backUrl'],
  data() {
    return {
      modalVisible: false,
      activeNotifications: false,
      showMenu: false,
      searchQuery: '',
      dataUser: JSON.parse(localStorage.getItem('dataUser')),
    };
  },

  components: {
    ModalProfile,
    BaseNavDetail,
  },
  methods: {
    BaseNavDetailpenModal() {
      this.modalVisible = true;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    doLogout() {
      this.$store.dispatch('updateUser', {});
      this.$store.dispatch('updateToken', '');
      localStorage.removeItem('token');
      this.$Toast.fire({
        type: 'success',
        title: 'Session destroy',
      });
      // this.$router.push("/");
      window.location.href = '/';
    },
  },
};
</script>
